<script>
export default {
  mounted: () => {
    window.onscroll = function () {
      onwindowScroll();
    };
    var navbar = document.getElementById("navbar");
    function onwindowScroll() {
      if (
        document.body.scrollTop > 50 ||
        document.documentElement.scrollTop > 50
      ) {
        navbar.style.backgroundColor = "#2e313a";
        navbar.style.padding = "10px";
      } else {
        navbar.style.backgroundColor = "";
        navbar.style.padding = "20px";
      }
    }
  },
  methods: {
    /**
     * Toggle menu
     */
    toggleMenu() {
      document.getElementById("navbarCollapse").classList.toggle("show");
    },
  },
};
</script>

<template>
  <!--Navbar Start-->
  <nav class="navbar navbar-expand-lg fixed-top navbar-custom sticky sticky-dark" id="navbar">
    <div class="container">
      <!-- LOGO -->
      <a class="navbar-brand logo text-uppercase" href="/">
        <img src="../assets/images/isologobl2.png" class="navbar-logo">
      </a>
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarCollapse"
        aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation" @click="toggleMenu()">
        <i class="mdi mdi-menu"></i>
      </button>
      <div class="collapse navbar-collapse" id="navbarCollapse">
        <ul class="navbar-nav ml-auto navbar-center" id="mySidenav" v-scroll-spy-active>
          <li class="nav-item">
            <a v-scroll-to="'#home'" href="javascript: void(0);" class="nav-link">Inicio</a>
          </li>
          <li class="nav-item">
            <a v-scroll-to="'#services'" href="javascript: void(0);" class="nav-link">Nosotros</a>
          </li>
          <li class="nav-item">
            <a v-scroll-to="'#conoce'" href="javascript: void(0);" class="nav-link">Pólizas</a>
          </li>
          <!--<li class="nav-item">
            <a v-scroll-to="'#blog'" href="javascript: void(0);" class="nav-link">Noticias</a>
          </li>-->
          <li class="nav-item">
            <a v-scroll-to="'#contact'" href="javascript: void(0);" class="nav-link">Contacto</a>
          </li>
          <!--<li class="nav-item">
            <a v-scroll-to="'#blog'" href="javascript: void(0);" class="nav-link">English</a>
          </li>-->
          <a href="https://public.nhseguros.com/#!policyIndividual/index?code=MjI4MDc%3D" target="_blank"
            class="btn btn-custom btn-rounded waves-effect waves-light mb-5" style="margin-top: 8px;">Compra tu seguro</a>
        </ul>
      </div>
    </div>
  </nav>
  <!-- Navbar End -->
</template>